import { Typography } from "../../components"

const Copyright = () => {
    return (<Typography size={'xs'} type={'regular'} className="max-sm:w-full text-[#c0c0c0]">{`©Copyright ${new Date().getFullYear()}, Spin Launch | Powered by Karyah.app`}</Typography>)
}

export default Copyright
